<script>
import uploadImg from '@/components/uploadImage/index.vue'
import PositionSelection from '@/components/project/PositionSelection.vue'
import gifts from '@/components/prize/gifts/index.vue'

export default {
  name: 'AddTaskStep',
  components: { PositionSelection, uploadImg, gifts },
  props: {
    value: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      item: {
        ...this.value
      },
      itemRules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传图标', trigger: 'blur' }
        ],
        completionDays: [
          { required: true, message: '请输入完成周期', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入内容介绍', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'blur' }
        ],
        autoAudit: [
          { required: true, message: '请选择自动审核', trigger: 'blur' }
        ],
        gifts: [
          { required: false, message: '请设置奖品', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    updateValue (val) {
      this.$emit('input', val)
    }
  },
  watch: {
    item: {
      handler: function (val, oldVal) {
        this.updateValue(val)
      },
      deep: true
    },
    value: {
      handler: function (val, oldVal) {
        console.log('value handler', val)
        this.item = val
      },
      deep: true
    }
  }
}
</script>
<template>
  <el-form label-width="100px" :model="item" :rules="itemRules" size="mini">
    <el-form-item label="标题" prop="title">
      <el-input v-model="item.title" placeholder="输入标题(前端显示)" :clearable="true"></el-input>
    </el-form-item>
    <el-form-item label="自动审核" required :prop="'autoAudit'">
      <el-radio-group v-model="item.autoAudit">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="步骤序号" prop="step">
      <el-input-number v-model="item.step" :step="1" :min="1" step-strictly></el-input-number>
    </el-form-item>
    <el-form-item label="步骤描述" prop="ruleInfo">
      <el-input type="textarea" placeholder="请输入内容" v-model="item.ruleInfo" maxlength="1000" show-word-limit></el-input>
    </el-form-item>
    <el-form-item label="奖品设置" prop="gifts">
      <gifts :giftList="item.gifts"></gifts>
    </el-form-item>
  </el-form>
</template>

<style scoped></style>
